import Animation from 'animation'
import * as d3 from 'd3-selection'
import * as shape from 'd3-shape'

/*
 * Parent animation class for all polar animations
 */
class PolarAnimation extends Animation {

  configure (axis, serie) {
    super.configure(axis, serie)

    if (this.yScale) {
      this.lineGenerator = shape.radialLine()

      this.lineGenerator.curve(shape.curveCatmullRomClosed.alpha(.5))
                        .angle((d, i) => {
                          return this.scalers.x.groupScale(d.rangeId, i)
                        })
                        .radius((d, i) => {
                          return this.yScale(d.raw, i)
                        })
    }


    return this
  }

  bindAndAnimate (container, node) {
    let serie = d3.select(node).datum()
      , dimensions = {
        width: this.scalers.x.plotScale.bandwidth(),
        height: this.chart.datum().dimensions.height
      }
      , group = d3.select(node)
                  .selectAll('.polar-line-group')
                  .data(d => [d])
      , enter = group.enter()
                     .append('g')
                     .attr('class', 'polar-line-group')
                     .attr('transform', d => {
                       return `translate(${dimensions.width / 2}, ${dimensions.height / 2})`
                     })
      , transition = group.merge(enter)
                          .attr('class', 'polar-line-group')
                          .transition(container)
                          .attr('transform', d => {
                            return `translate(${dimensions.width / 2}, ${dimensions.height / 2})`
                          })
      , exit = this.exitingSeries.filter(exiting => exiting.id === serie.id)

    this.animate(serie, enter, group, transition, exit)
  }

}

export default PolarAnimation
